<template>
  <div v-if="authenticate" class="main-app">
    <app-header></app-header>
    <payment-method-banner></payment-method-banner>
    <transition>
      <router-view></router-view>
    </transition>
  </div>

  <div
    v-else
    class="w-screen min-h-screen flex flex-col justify-center items-center"
  >
    <i class="fa fa-circle-notch fa-spin fa-3x"></i>
    <p class="mt-4">Please wait...</p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({ authenticate: "isAuthenticated" }),
  },
};
</script>

<style scoped>
/*
 * From the `sm` breakpoint (640px) the wrapper in main/index.blade.php becomes
 * a flex row with the 6rem wide side nav, so
 * the page fills whatever the nav leaves instead of a fixed calc(100% - 6rem).
 * Keep `.main-app` clamped to the viewport: without `min-width: 0`, Safari
 * sizes this flex item from the intrinsic width of the horizontal file strip
 * (N cards x 16rem), so every `w-full` child grows far past the screen and
 * its centered text looks missing.
 */
.main-app {
  min-width: 0;
  max-width: 100%;
}

@media (min-width: 640px) {
  .main-app {
    flex: 1 1 0%;
  }
}
</style>
